/**
 * ActionArchetype.js
 * Statistical targets for Action/Chase music.
 * Traits: High Energy, Fast Harmonic Rhythm, Percussive Dominance.
 */

import { ACTIVE_ARCHETYPE } from './BaseArchetype.js';

export const ACTION_ARCHETYPE = {
    ...ACTIVE_ARCHETYPE,

    // Harmonic Rhythm: Fast. Changes every bar or half-bar.
    harmonicRhythm: {
        ...ACTIVE_ARCHETYPE.harmonicRhythm,
        target: 0.5, // 2 chords per bar (Fast/Hyper)
        tolerance: 0.25
    },

    // Voice Distribution: "Punchy".
    // Heavy Low (Brass/Percussion/Bass) and Mid (Horns/Strings).
    voiceDistribution: {
        ...ACTIVE_ARCHETYPE.voiceDistribution,
        low: 0.35,
        mid: 0.30,
        high: 0.35, // Increased for Hi-Hats/Synths/Ostinatos
        tolerance: 0.15,
        tuttiThreshold: 0.8 // Action is often Tutti
    },

    // Dynamic Range: High (Accents vs Sustains).
    // Needs strong attacks (Staccato/Marcato).
    dynamicRange: {
        ...ACTIVE_ARCHETYPE.dynamicRange,
        minVariance: 0.20,
        targetVariance: 0.30
    },

    // Interval Entropy: Angular. Leaps and jagged lines.
    intervalEntropy: {
        ...ACTIVE_ARCHETYPE.intervalEntropy,
        stepRatio: 0.40, // Low step ratio (More leaps)
        tolerance: 0.2
    },

    // Harmonic Consonance: Dissonance is good (Tension).
    harmonicConsonance: {
        ...ACTIVE_ARCHETYPE.harmonicConsonance,
        polarity: 'dissonant' // Prefers tension
    }
};
